import getSenderNameForBlockMenuItem from './getSenderNameForBlockMenuItem';
import isSenderSelf from 'owa-mail-store/lib/selectors/isSenderSelf';
import Message from 'owa-service/lib/contract/Message';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';

// Should only show block option if in the proper folder, user cannot block themselves
export default function shouldAddBlockSafeSenderMenuItemForFolder(item: Message): boolean {
    return (
        !doesFolderIdEqualName(item.ParentFolderId.Id, 'drafts') &&
        item.Sender &&
        item.Sender.Mailbox &&
        !isSenderSelf(item.Sender.Mailbox.EmailAddress) &&
        getSenderNameForBlockMenuItem(item) != null
    );
}
